import { imagenPathS3 } from '../decorators/imagenPathS3';
import { Imagenes } from '../Imagenes';
import { Rescatable } from '../Rescatable';

export class EspacioSuperior extends Rescatable {
  static _name = 'EspacioSuperior';
  static pathRequest = Rescatable.pathRequestStatic + 'espacios/superiores';
  static pk: keyof EspacioSuperior = 'id';
  codigoColor: string;
  descripcion: string;
  estado: number;
  fechaLanzamiento: string;
  fechaVencimiento: string;
  id: number;
  link: string;
  orden: number;
  ventana: boolean;
  @imagenPathS3('/espacioWebSuperior')
  nombre: string;
  @imagenPathS3('/espacioWebSuperior')
  nombreMobile: string;
  @imagenPathS3('/espacioWebSuperior')
  nombreTablet: string;
}
